/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Tools_PlannerInputs */

const en_control_tools_planner = /** @type {(inputs: Control_Tools_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record your combat choices. Save locally and share a build.`)
};

const zh_control_tools_planner = /** @type {(inputs: Control_Tools_PlannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记录各阶段的能力选择，并生成可分享的配置链接。`)
};

/**
* | output |
* | --- |
* | "Record your combat choices. Save locally and share a build." |
*
* @param {Control_Tools_PlannerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_tools_planner = /** @type {((inputs?: Control_Tools_PlannerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Tools_PlannerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_tools_planner(inputs)
	return zh_control_tools_planner(inputs)
});
export { control_tools_planner as "control.tools.planner" }